import PlentyApiClient from "./base";

export const sellerboardApi = {
  create_report: (reportData) => {
    return PlentyApiClient.post("/sellerboard/reports/", reportData);
  },

  get_all_reports: () => {
    return PlentyApiClient.get("/sellerboard/reports/");
  },

  update_report: (reportId, updateData) => {
    return PlentyApiClient.put(`/sellerboard/reports/${reportId}`, updateData);
  },

  delete_report: (reportId) => {
    return PlentyApiClient.delete(`/sellerboard/reports/${reportId}`);
  },

  download_report: (reportType) => {
    return PlentyApiClient.get(`/sellerboard/reports/${reportType}/download`);
  },

  process_report_to_amazon_articles: (reportType) => {
    return PlentyApiClient.post(`/sellerboard/reports/${reportType}/process`);
  },
};
